import { TNewOrderForm } from "@/entities/new-order";
import { TReviewValue } from "@/entities/new-order/types/new-order-keywords.type";
import { getAppStore } from "@/shared/helpers";
import BasicRadioRow from "@/UI/BasicRadioRow";
import { Flex } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import clsx from "clsx";
import { useFormContext } from "react-hook-form";
import styles from "./country-review.module.scss";

interface CountryReviewItemProps {
  index: number;
  review: TReviewValue;
  currentIndex: number;
  date: string;
}

function CountryReviewItem({
  index,
  review,
  currentIndex,
  date,
}: CountryReviewItemProps) {
  const { id, title, review: content, rating } = review;

  const { watch, setValue } = useFormContext<TNewOrderForm>();

  const { app } = watch();

  const isTitleNeeded = app ? getAppStore(app.url) === "apple" : false;

  const handleSetTitle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTitle = e.target.value;

    setValue(
      `countriesList.${currentIndex}.keywords.${date}.${index}.title`,
      newTitle,
    );
  };

  const handleSetContent = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newContent = e.target.value;

    setValue(
      `countriesList.${currentIndex}.keywords.${date}.${index}.review`,
      newContent,
    );
  };

  const handleSetRate = (newRate: 4 | 5) => {
    setValue(
      `countriesList.${currentIndex}.keywords.${date}.${index}.rating`,
      newRate,
    );
  };

  const handleDeleteReview = () => {
    const dateReviews = watch().countriesList[currentIndex].keywords[date];

    if (!Array.isArray(dateReviews)) {
      return;
    }

    const newDateReviews = dateReviews.filter((item) => item.id !== id);

    setValue(`countriesList.${currentIndex}.keywords.${date}`, newDateReviews);
  };

  return (
    <Flex direction="column" gap="sm">
      <Flex align="center" justify="space-between">
        <Flex align="center" gap="xs">
          <span className={styles.reviewHeader}>Review #{index + 1}</span>
          <button
            className={styles.deleteReviewButton}
            onClick={handleDeleteReview}
          >
            <IconX size={24} />
          </button>
        </Flex>
        <Flex align="center" gap="lg">
          <BasicRadioRow
            value={`${id}-4`}
            name={`radioName-${id}`}
            text="4-Star"
            onChange={() => handleSetRate(4)}
            checked={rating === 4}
          />
          <BasicRadioRow
            value={`${id}-5`}
            name={`radioName-${id}`}
            text="5-Star"
            onChange={() => handleSetRate(5)}
            checked={rating === 5}
          />
        </Flex>
        <div
          className={clsx(
            styles.reviewInputContainer,
            !isTitleNeeded && styles.hidden,
          )}
        >
          <input
            type="text"
            id={`${id}-title`}
            className={clsx(styles.reviewInput, styles.reviewTitleInput)}
            value={title}
            onChange={handleSetTitle}
            placeholder=" "
          />
          <label htmlFor={`${id}-title`} className={styles.reviewLabel}>
            Title
          </label>
        </div>
      </Flex>
      <div className={styles.reviewInputContainer}>
        <input
          type="text"
          id={`${id}-content`}
          className={styles.reviewInput}
          value={content}
          onChange={handleSetContent}
          placeholder=" "
        />
        <label htmlFor={`${id}-content`} className={styles.reviewLabel}>
          Content
        </label>
      </div>
    </Flex>
  );
}

export default CountryReviewItem;
